import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import {Router} from '@angular/router';
import {IecTaskService} from '../services/iec-task-service';
import {PersonLoginService} from '../services/person-login-service';
import {TaskResponseService} from '../services/task-response-service';
import {StringUtils} from '../utils/string-utils';
import {CreditExceptionTaskResponse} from './credit-exception-task-response';
import {IecTask} from './iec-task';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'credit-exceptions-task',
    templateUrl: './credit-exceptions-task.component.html',
    styleUrls: ['./credit-exceptions-task.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatIcon, MatProgressSpinner]
})
export class CreditExceptionsTaskComponent implements OnInit, OnChanges {
  readonly taskId = input.required<string>({ alias: 'task-id' });
  private readonly personLoginService = inject(PersonLoginService);
  private readonly taskResponseService = inject(TaskResponseService);
  private readonly iecTaskService = inject(IecTaskService);
  private readonly router = inject(Router);


  readonly task = signal<IecTask>(undefined!);
  response!: CreditExceptionTaskResponse;
  readonly isBusy = signal<boolean>(false);
  readonly errorMessage = signal<string>(undefined!);

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.response = new CreditExceptionTaskResponse();
      this.personLoginService.getCachedLogin();
      this.loadTask();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['taskId'].firstChange) {
      this.loadTask();
    }
  }

  private loadTask(): void {
    const taskIdString: string = this.taskId();
    if (taskIdString && !isNaN(+taskIdString) && +taskIdString > 0) {
      this.iecTaskService.getTask(+taskIdString).subscribe(result => this.task.set(result), error => this.handleError(error));
    } else {
      this.router.navigate(['main']);
    }
  }

  saveResponse(): void {
    this.isBusy.set(true);
    this.taskResponseService.creditExceptions(this.task().id, this.response).subscribe(() => this.router.navigate(['main']), error => this.handleError(error));
  }

  private handleError(error: HttpErrorResponse) {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

}
